/**
 * Smart collapse helpers for tree expansion.
 */

import type { TreeNode } from "../types";

/**
 * Determine if a node should be auto-expanded.
 *
 * All nodes are expanded by default for full tree visibility.
 * Users can manually collapse nodes if needed.
 */
export function shouldAutoExpand(node: TreeNode, isCurrent: boolean): boolean {
  // Always expand all nodes by default for full visibility
  return true;
}

/**
 * Compute the set of node IDs that should be auto-expanded based on smart collapse rules.
 */
export function computeSmartExpandedIds(
  rootNode: TreeNode,
  currentNodeId: string
): Set<string> {
  const expandedIds = new Set<string>();

  function traverse(node: TreeNode) {
    const isCurrent = node.id === currentNodeId;

    if (shouldAutoExpand(node, isCurrent)) {
      expandedIds.add(node.id);
    }

    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        traverse(child);
      }
    }
  }

  traverse(rootNode);
  return expandedIds;
}
